import analytics from '@noths/analytics';

export const trackSignInClick = () => {
  analytics.track({
    event: 'account_action',
    eventCategory: 'User Account',
    eventAction: 'Login form submission',
    eventLabel: undefined,
  });
};

export const trackRegisterClick = url => {
  analytics.track({
    event: 'account_clicks',
    eventCategory: 'User Account',
    eventAction: 'Click',
    eventLabel: 'Register CTA',
    destinationUrl: url,
  });
};

export const trackRegisterSucceeded = (email, marketingEmailsChecked) => {
  // sending checked as numeric in line with SubTwo requirements
  const checkedAsNumeric = marketingEmailsChecked === true ? 1 : 0;
  analytics.track({
    event: 'account_action',
    eventCategory: 'User Account',
    eventAction: 'Registration',
    eventLabel: undefined,
    user_email: email,
    email_optin: checkedAsNumeric,
  });
};

export const trackRegisterEmailAlreadyExistsFailure = () => {
  analytics.track({
    event: 'account_events',
    eventCategory: 'User Account',
    eventAction: 'Failed registration',
    eventLabel: 'Email already exists',
  });
};

export const trackRegisterFormSubmitClick = () => {
  analytics.track({
    event: 'account_action',
    eventCategory: 'User Account',
    eventAction: 'Registration form submission',
    eventLabel: undefined,
  });
};

export const trackSignInCredentialsInvalid = () => {
  analytics.track({
    event: 'account_events',
    eventCategory: 'User Account',
    eventAction: 'Failed login',
    eventLabel: 'Invalid credentials',
  });
};

export const trackSignInUserDisabled = () => {
  analytics.track({
    event: 'account_events',
    eventCategory: 'User Account',
    eventAction: 'Failed login',
    eventLabel: 'Account disabled',
  });
};

export const trackPasswordResetRequiredError = () => {
  analytics.track({
    event: 'account_events',
    eventCategory: 'User Account',
    eventAction: 'Failed login',
    eventLabel: 'Password reset required',
  });
};

export const trackMarketingPreferencesRegistration = (emailOptIn, postOptIn) => {
  analytics.track({
    event: 'marketing_preferences',
    eventCategory: 'Marketing preferences - registration',
    eventAction: `email: ${emailOptIn} | post: ${postOptIn}`,
    eventLabel: undefined,
  });
};

export const trackMarketingPreferencesUpdate = (
  { currentStatus: emailStatus, hasChanged: emailChanged },
  { currentStatus: postStatus, hasChanged: postChanged }
) => {
  let changes = [];

  if (emailChanged) {
    changes = changes.concat([`email: ${emailStatus}`]);
  }

  if (postChanged) {
    changes = changes.concat([`post: ${postStatus}`]);
  }

  analytics.track({
    event: 'marketing_preferences',
    eventCategory: 'Marketing preferences - update',
    eventAction: changes.join(' | '), // what changed
    eventLabel: `email: ${emailStatus} | post: ${postStatus}`, // final state
  });
};

export const trackSignInSuccess = () => {
  analytics.track({
    event: 'account_action',
    eventCategory: 'User Account',
    eventAction: 'Login',
    eventLabel: undefined,
  });
};

export const trackForgotPasswordClick = path => {
  analytics.track({
    event: 'account_clicks',
    eventCategory: 'User Account',
    eventAction: 'Click',
    eventLabel: 'Forgotten password?',
    destinationUrl: path,
  });
};
